const REGEX = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^\+?[1-9]\d{9,14}$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_%^&*()+=?/\\.,:;'"<>|~`{}[\]-])[A-Za-z\d@$!%*?&#_%^&*()+=?/\\.,:;'"<>|~`{}[\]-]{8,}$/,
  NAME: /^[a-zA-Z\s]{2,50}$/,
  /** Username: min 8 chars, letters and numbers only (no spaces or special chars). */
  USERNAME: /^[a-zA-Z0-9]{8,}$/,
};

export { REGEX };
